import { ReactNode, useMemo, memo } from 'react';
import useAlias from '@src/hooks/useAlias';

interface FormattedAliasProps {
  id: string;
  values?: Record<string, string | number | ReactNode>;
  defaultMessage?: string;
}

const FormattedAlias = memo(function FormattedAlias({
  id,
  values,
  defaultMessage,
}: FormattedAliasProps) {
  const alias = useAlias();
  const message = alias(id) || defaultMessage || id;

  const content = useMemo(() => {
    if (!values) {
      return message;
    }

    const parts: ReactNode[] = [];
    let lastIndex = 0;
    const regex = /\{(\w+)\}/g;
    let match;

    while ((match = regex.exec(message)) !== null) {
      if (match.index > lastIndex) {
        parts.push(message.substring(lastIndex, match.index));
      }

      parts.push(values[match[1]] ?? `{${match[1]}}`);
      lastIndex = regex.lastIndex;
    }

    if (lastIndex < message.length) {
      parts.push(message.substring(lastIndex));
    }

    return parts;
  }, [message, values]);

  return <>{content}</>;
});

export default FormattedAlias;
